/*
NOTE: this file only temporarily resides in scratch-gui.
Nearly identical code appears in scratch-www, and the two should
eventually be consolidated.
*/

import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

import MenuBarMenu from './menu-bar-menu.jsx';
import {MenuSection} from '../menu/menu.jsx';
import MenuItemContainer from '../../containers/menu-item.jsx';
import UserAvatar from './user-avatar.jsx';
import dropdownCaret from './dropdown-caret.svg';

import styles from './account-nav.css';

const AccountNavComponent = ({
    className,
    isOpen,
    isRtl,
    menuBarMenuClassName,
    onClick,
    onClose,
    onLogOut,
    onOpenMyStuff,
    onOpenPassword,
    onOpenProfile,
    profileUrl,
    myStuffUrl,
    avatarUrl,
    myClassesUrl,
    myClassUrl,
    accountSettingsUrl,
    username,
    avatarBadge
}) => {
    const closeAfterClick = handler => {
        if (!handler) return null;
        return () => {
            handler();
            if (onClose) onClose();
        };
    };

    const handleOpenProfile = closeAfterClick(onOpenProfile);
    const handleOpenPassword = closeAfterClick(onOpenPassword);
    const handleOpenMyStuff = closeAfterClick(onOpenMyStuff);
    const handleLogOut = closeAfterClick(onLogOut);

    return (
        <React.Fragment>
            <div
                className={classNames(
                    styles.userInfo,
                    className
                )}
                onClick={onClick}
            >
                {avatarUrl ? (
                    <UserAvatar
                        className={styles.avatar}
                        wrapperClassName={styles.avatarWrapper}
                        imageUrl={avatarUrl}
                        showAvatarBadge={!!avatarBadge}
                    />
                ) : null}
                <span className={styles.profileName}>
                    {username}
                </span>
                <div className={styles.dropdownCaretPosition}>
                    <img
                        className={styles.dropdownCaretIcon}
                        src={dropdownCaret}
                    />
                </div>
            </div>
            <MenuBarMenu
                className={menuBarMenuClassName}
                open={isOpen}
                // note: the Rtl styles are switched here, because this menu is justified
                // opposite all the others
                place={isRtl ? 'right' : 'left'}
                onRequestClose={onClose}
            >
                {onOpenProfile ? (
                    <MenuItemContainer onClick={handleOpenProfile}>
                        <FormattedMessage
                            defaultMessage="Profile"
                            description="Text to link to my user profile, in the account navigation menu"
                            id="gui.accountMenu.profile"
                        />
                    </MenuItemContainer>
                ) : profileUrl ? (
                    <MenuItemContainer href={profileUrl}>
                        <FormattedMessage
                            defaultMessage="Profile"
                            description="Text to link to my user profile, in the account navigation menu"
                            id="gui.accountMenu.profile"
                        />
                    </MenuItemContainer>
                ) : null}

                {onOpenPassword ? (
                    <MenuItemContainer onClick={handleOpenPassword}>
                        <FormattedMessage
                            defaultMessage="Ubah Password"
                            description="Text to open password change form in the account navigation menu"
                            id="gui.accountMenu.ikoosChangePassword"
                        />
                    </MenuItemContainer>
                ) : null}

                {onOpenMyStuff ? (
                    <MenuItemContainer onClick={handleOpenMyStuff}>
                        <FormattedMessage
                            defaultMessage="Project Saya"
                            description="Text to open list of my projects in the account navigation menu"
                            id="gui.accountMenu.ikoosProjects"
                        />
                    </MenuItemContainer>
                ) : myStuffUrl ? (
                    <MenuItemContainer href={myStuffUrl}>
                        <FormattedMessage
                            defaultMessage="My Stuff"
                            description="Text to link to list of my projects, in the account navigation menu"
                            id="gui.accountMenu.myStuff"
                        />
                    </MenuItemContainer>
                ) : null}

                {myClassesUrl ? (
                    <MenuItemContainer href={myClassesUrl}>
                        <FormattedMessage
                            defaultMessage="My Classes"
                            description="Text to link to my classes (if I am a teacher), in the account navigation menu"
                            id="gui.accountMenu.myClasses"
                        />
                    </MenuItemContainer>
                ) : null}

                {myClassUrl ? (
                    <MenuItemContainer href={myClassUrl}>
                        <FormattedMessage
                            defaultMessage="My Class"
                            description="Text to link to my class (if I am a student), in the account navigation menu"
                            id="gui.accountMenu.myClass"
                        />
                    </MenuItemContainer>
                ) : null}

                {accountSettingsUrl ? (
                    <MenuItemContainer href={accountSettingsUrl}>
                        <FormattedMessage
                            defaultMessage="Account settings"
                            description="Text to link to my account settings, in the account navigation menu"
                            id="gui.accountMenu.accountSettings"
                        />
                    </MenuItemContainer>
                ) : null}

                {onLogOut ? (
                    <MenuSection>
                        <MenuItemContainer onClick={handleLogOut}>
                            <FormattedMessage
                                defaultMessage="Sign out"
                                description="Text to link to sign out, in the account navigation menu"
                                id="gui.accountMenu.signOut"
                            />
                        </MenuItemContainer>
                    </MenuSection>
                ) : null}
            </MenuBarMenu>
        </React.Fragment>
    );
};

AccountNavComponent.propTypes = {
    className: PropTypes.string,

    isOpen: PropTypes.bool,
    isRtl: PropTypes.bool,

    menuBarMenuClassName: PropTypes.string,

    onClick: PropTypes.func,
    onClose: PropTypes.func,
    onLogOut: PropTypes.func,
    onOpenMyStuff: PropTypes.func,
    onOpenPassword: PropTypes.func,
    onOpenProfile: PropTypes.func,

    username: PropTypes.string,
    avatarBadge: PropTypes.number,

    avatarUrl: PropTypes.string,
    myStuffUrl: PropTypes.string,
    profileUrl: PropTypes.string,
    myClassesUrl: PropTypes.string,
    myClassUrl: PropTypes.string,
    accountSettingsUrl: PropTypes.string
};

export default AccountNavComponent;
